import "./filters.scss";

const selectors = {
 container: "[data-filters]",
 filtersHeader: "[data-filters-header]",
 filtersList: "[data-filters-list]",
 filtersItems: "[data-filters-list] .accordion__item",
 active: "active-filter",
};

const getActiveFilter = (headers) => {
 const hash = window.location.hash;

 if (!hash) return [...headers][0];

 return [...headers].find((header) => header.dataset.filtersHeader === decodeURI(hash).replace("#", ""));
};

const handleFilterClick = (headers, items, activeHeader) => {
 headers.forEach((header) => {
   header.classList.toggle(selectors.active, header === activeHeader);
 });

 items.forEach((item) => {
  if (activeHeader.dataset.filtersHeader === headers[0].dataset.filtersHeader) {
    item.classList.add(selectors.active);
  } else {
    item.classList.toggle(selectors.active, item.dataset.accItemKey === activeHeader.dataset.filtersHeader);
  }
  });
};

const initFilters = (container) => {
 const headers = container.querySelectorAll(selectors.filtersHeader);
 const items = container.querySelectorAll(selectors.filtersItems);

 const activeHeader = getActiveFilter(headers);

 headers.forEach((header) => {
   const button = header.querySelector('button');

   button.addEventListener('click', () =>
     handleFilterClick(headers, items, header)
   );
 });

 handleFilterClick(headers, items, activeHeader);
};

document.addEventListener("DOMContentLoaded", async function () {
 const containers = document.querySelectorAll(selectors.container);

 containers.forEach(initFilters);
});

